var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Nav-logo",
    width: "50px",
    height: "50px",
    viewBox: "0 0 100.1 73.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-purple)",
    d: "M53.3,14.2l1-14.2L27.4,7.5c-1.8,0.5-3.5,1.1-5.1,1.8c-2.2,0.9-4.9,2.2-7.7,4.1 c0,0,0,0,0-0.1c-5.5,3.6-8.4,7.3-9.5,8.9c-0.1,0.2-0.3,0.5-0.4,0.7c0,0,0,0.1-0.1,0.1l0,0C0.3,30.3-1.2,39.2,1.1,48 c4.6,17.6,22.6,28.2,40.2,23.6c1.1-0.3,2.1-0.6,3.2-1c0.6-1.7,0.6-3.7-0.1-5.7c-0.7-2-2.1-3.9-4.2-6.2c-0.4-0.4-0.9-0.9-1.3-1.3 c-1.7-1.6-3.4-3.3-4.6-5.5c-0.7-1.2-1.1-2.7-1.2-4.2c-1.1,0-2.1-0.2-3.2-0.6c-3.8-1.6-5.5-6-3.8-9.8s6-5.5,9.8-3.8 c3.8,1.6,5.5,6,3.8,9.8c-0.8,1.9-2.4,3.3-4.2,4c0,1.2,0.4,2.5,1,3.5c1,1.8,2.5,3.3,4.2,4.9c0.5,0.4,0.9,0.9,1.4,1.3 c1.5,1.6,3.7,4,4.8,7c0.6,1.8,0.8,3.6,0.6,5.3c10.7-5.1,17.7-15.6,18.6-27.2l6.8-4.9L53.3,14.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLogo);
export default __webpack_public_path__ + "static/media/nav-logo.4106c8a1374ec3ee49a8c201d1a0732d.svg";
export { ForwardRef as ReactComponent };